import { render, staticRenderFns } from "./ManageBenefits.vue?vue&type=template&id=0d824b95&scoped=true&"
import script from "./ManageBenefits.vue?vue&type=script&lang=js&"
export * from "./ManageBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d824b95",
  null
  
)

export default component.exports